import Axios, { AxiosError } from 'axios';
import { INTERNAL_SERVER_ERROR, UNAUTHORIZED, UNPROCESSABLE_ENTITY, CONFLICT } from "http-status-codes";
import { spinner } from '../spinner';

function baseAxios(allowedErrors: number[]) {
  const axios = Axios.create({
    headers:{
      'X-Galaxy-Cruise-Client-Version': '202012029',
    }
  })
  axios.interceptors.request.use((config) => {
    spinner.start()
    return config
  })
  axios.interceptors.response.use(
    (response) => {
      spinner.stop()
      return response
    },
    (error: AxiosError) => {
      spinner.stop()
      do {
        if (!error.response) {
          alert(`No response`)
          location.href = `#/`
          location.reload()
          break
        }
        if (allowedErrors.indexOf(error.response.status) >= 0) {
          break
        }
        switch (error.response.status) {
          case INTERNAL_SERVER_ERROR:
            alert(`Server error:\n${error.response.data}`)
            break
          case UNAUTHORIZED:
            location.href = `#/login?next=${encodeURIComponent(location.hash.substring(1))}`
            location.reload()
            break
          case CONFLICT:
            location.href = `?${+(new Date())}`
            break
          default:
            alert(error)
            location.href = `#/`
            location.reload(true)
            break
        }
      } while (false)
      return Promise.reject(error)
    })
  return axios
}

const api = {
  get default() {
    return this.passErrors(UNPROCESSABLE_ENTITY)
  },
  passErrors(...allowedErrors: number[]) {
    const axios = baseAxios(allowedErrors)
    return axios
  },
}

export { api };
